import { createAsyncThunk } from "@reduxjs/toolkit";
import Sessions from "utils/Sessions";
import ApiService from "../ApiService/ApiService";

export const createInquiryThunk = createAsyncThunk("inquiry/create", async (data) => {
  const res = await ApiService.post("inquiry", data, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((error) => error.response);
  return res;
});

export const getAllInquiriesThunk = createAsyncThunk("inquiry/getAll", async (param) => {
  const res = await ApiService.get(`inquiry${param ? `?${param}` : ""}`, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((error) => error.response);

  const params = new URLSearchParams(param);
  const page = params.get("page");
  return page === "0" || page === null
    ? { data: res?.data, type: "add", status: res?.status, byPassSlice: false }
    : { data: res?.data, type: "append", status: res?.status, byPassSlice: false };
});

export const getInquiryByIdThunk = createAsyncThunk("inquiry/getById", async (id) => {
  const res = await ApiService.get(`inquiry/${id}`, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((error) => error.response);
  return res;
});

export const updateInquiryStatusThunk = createAsyncThunk(
  "inquiry/updateStatus",
  async ({ id, status, rejectionReason, loanType }) => {
    const res = await ApiService.patch(
      `inquiry/${id}/status`,
      { status, rejectionReason, loanType },
      {
        headers: { Authorization: `Bearer ${Sessions.userToken}` },
      }
    )
      .then((r) => r)
      .catch((error) => error.response);
    return res;
  }
);

export const updateInquiryThunk = createAsyncThunk("inquiry/update", async ({ id, data }) => {
  const res = await ApiService.patch(`inquiry/${id}`, data, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((error) => error.response);
  return res;
});

export const deleteInquiryThunk = createAsyncThunk("inquiry/delete", async (id) => {
  const res = await ApiService.delete(`inquiry/${id}`, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((error) => error.response);
  return res;
});

export const getInquiryStatsThunk = createAsyncThunk("inquiry/getStats", async () => {
  const res = await ApiService.get("inquiry/stats", {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((error) => error.response);
  return res?.data;
});
